import { updatePostalCodeApi } from "api/shopping-cart/updatePostalCodeApi";
import { hideLoader } from "../loader/hideLoader";
import { showLoader } from "../loader/showLoader";
import { refreshShoppingCart } from "./refreshShoppingCart";

export function updatePostalCode(postalCode: any, { loader = true } = {}) {
  return (dispatch: any) => {
    if (loader) {
      dispatch(showLoader());
    }
    updatePostalCodeApi(postalCode).then(() => {
      dispatch(hideLoader());
      dispatch(refreshShoppingCart(null, { loader: false }));
    });
  };
}
